module.exports = __webpack_public_path__ + "static/media/home-background.17db1dbd.png";